var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHowItWorks2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 240,
    height: 230,
    viewBox: "0 0 240 230",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-HowItWorks2"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 240,
    height: 230
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "HowItWorks2",
    clipPath: "url(#clip-HowItWorks2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13726",
    "data-name": "Group 13726",
    transform: "translate(-834 -1271)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_752",
    "data-name": "Ellipse 752",
    cx: 114,
    cy: 114,
    r: 114,
    transform: "translate(846 1272)",
    fill: "#ffe42d"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_13707",
    "data-name": "Group 13707",
    transform: "translate(834 1309)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_14273",
    "data-name": "Path 14273",
    d: "M756.925,148.1c2.63,2.247,2.7,3.9.244,6.358-1.962,1.966-3.938,3.918-5.965,5.935a3.192,3.192,0,0,0,1.94.276q25.812.016,51.622.007a11.135,11.135,0,0,1,2.831.239,3.285,3.285,0,0,1-.575,6.483c-.6.043-1.2.023-1.8.023H751.353c.052.778.6,1.036.96,1.4,1.817,1.861,3.707,3.653,5.481,5.552a3.375,3.375,0,0,1,.165,4.851,3.244,3.244,0,0,1-4.839-.07q-6.406-6.217-12.63-12.621c-1.57-1.613-1.463-3.448.174-5.06,4.524-4.455,8.857-9.1,13.559-13.378Z",
    transform: "translate(-720.187 -148.096)",
    fill: "#272c48"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14274",
    "data-name": "Path 14274",
    d: "M736.426,242.162a3.438,3.438,0,0,0,1.382-1.108q20.705-20.69,41.4-41.4c3.763-3.766,8.183-5.1,13.3-3.451a11.574,11.574,0,0,1,7.322,6.652c.444,1.029.727,1.362,1.885.678a12.354,12.354,0,0,1,15.62,18.568c-1.877,2.29-4.08,4.265-6.159,6.357q-8.674,8.732-17.412,17.4c-.884.876-.926,1.235.3,1.824a12.3,12.3,0,0,1,5.4,17.415c-.519.9-.378,1.19.546,1.611,8.4,3.818,10.271,14.222,3.54,20.493-8.857,8.252-17.751,16.476-26.891,24.41a34.92,34.92,0,0,1-46.939-.963c-5.184-4.847-10.475-9.629-14.748-15.345a31.924,31.924,0,0,1-6.608-19.128c-.151-20.613-.107-41.229-.049-61.844.018-6.551,5.855-10.919,12.41-9.518,6.4,1.367,10.642,5.911,11.728,12.671,1.251,7.795,2.439,15.6,3.661,23.4C736.176,241.28,736.3,241.661,736.426,242.162ZM715.051,245.7q0,14.562.005,29.124a27.044,27.044,0,0,0,5.821,17.152c3.855,4.878,8.495,9.043,12.969,13.33a28.383,28.383,0,0,0,39.062.717c3.674-3.246,7.278-6.572,10.906-9.871q7.551-6.867,15.081-13.756a5.479,5.479,0,0,0,1.59-6.27,5.7,5.7,0,0,0-9.09-2.226c-1.034.831-2.047,1.645-3.5,1.3-2.74-.643-3.536-3.679-1.468-5.858s4.273-4.221,6.334-6.4a5.671,5.671,0,1,0-8.077-7.961c-1.3,1.241-2.546,2.548-3.834,3.808a36.342,36.342,0,0,1-3.167,2.973,3.189,3.189,0,0,1-4.364-.347,3.319,3.319,0,0,1-.23-4.273,13.143,13.143,0,0,1,1.495-1.674q18.093-18.106,36.193-36.2c.424-.424.861-.841,1.246-1.3a5.6,5.6,0,0,0-2.432-8.96c-2.731-.956-4.819.16-6.725,2.07q-18.285,18.337-36.619,36.626a9.217,9.217,0,0,1-1.7,1.454,3.26,3.26,0,0,1-4.927-2.829c-.017-1.463.894-2.384,1.82-3.311q15.073-15.075,30.145-30.15a13.821,13.821,0,0,0,1.429-1.536,5.425,5.425,0,0,0,.584-5.938,5.31,5.31,0,0,0-4.931-3.1,6.365,6.365,0,0,0-4.863,2.262q-17.175,17.219-34.385,34.4-6.316,6.316-12.632,12.633a3.466,3.466,0,0,1-3.671,1.093,3.385,3.385,0,0,1-2.4-2.974c-.368-2.319-.742-4.638-1.109-6.958-1.314-8.292-2.58-16.592-3.962-24.874a7.353,7.353,0,0,0-5.39-6.228c-3.453-1.037-5.2.28-5.2,3.873Q715.04,230.608,715.051,245.7Z",
    transform: "translate(-708.263 -166.27)",
    fill: "#272c48"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHowItWorks2);
export default __webpack_public_path__ + "static/media/HowItWorks2.24cf375e0eb6898f619c18411527d2d0.svg";
export { ForwardRef as ReactComponent };